import { I as p, a as v } from "../separate-component-helper-chunks/input-format-CPc-kSNP.js";
import { i as g, x as f, T as b, n as y, a as s, r as $ } from "../separate-component-helper-chunks/abstract-base-xBS_db8B.js";
import { o as n } from "../separate-component-helper-chunks/if-defined-CfkW11V1.js";
import { l as u } from "../separate-component-helper-chunks/live-rg_JtnMg.js";
import { B as T, I as w } from "../separate-component-helper-chunks/form-base-BjmCAmbT.js";
import { I as d } from "../separate-component-helper-chunks/icon-position-D4P-w4B1.js";
import { B as I } from "../separate-component-helper-chunks/beacon-primitive-ChVMWFlW.js";
import { b as S } from "../separate-component-helper-chunks/query-assigned-DFUTWPNn.js";
const o = {
  beaconTagName: "beacon-input-field",
  formatProp: "format",
  formatTypeAttr: "format-type",
  formatTypeProp: "formatType",
  iconUrlProp: "icon-url",
  iconPositionProp: "icon-position",
  iconCSSVar: "--input-field-icon",
  beaconNestedComponents: ["beacon-error"],
  beaconErrorTagName: "beacon-error",
  HINT_ID: "hint",
  ERROR_ID: "error"
}, P = g`label,.label{font-size:var(--beacon-form-label-font-size);font-weight:var(--beacon-form-label-font-weight);line-height:var(--beacon-form-label-font-line-height);margin:0;padding:0}.hint{font-size:var(--beacon-form-font-size);line-height:var(--beacon-form-font-line-height);margin:0}input,select,textarea{color:var(--beacon-form-field-color-text-default)}[aria-disabled=true]{caret-color:transparent;color:var(--beacon-form-field-color-text-inactive);cursor:not-allowed}input{--border-color: var(--beacon-form-field-color-border-default);--border-size: var(--beacon-form-field-size-border-width-default);--font-color: var(--beacon-form-field-color-text-default);background-color:var(--beacon-form-field-color-background);block-size:var(--beacon-form-field-size-block);border:var(--border-size) solid var(--border-color);border-radius:var(--beacon-form-field-size-border-radius);color:var(--font-color);font-size:var(--beacon-form-font-size);inline-size:var(--beacon-custom-form-field-inline-size, 100%);line-height:var(--beacon-form-font-line-height);margin-block-start:var(--beacon-custom-form-field-space-margin-block-start, var(--beacon-form-field-space-margin));margin-inline-start:0;padding-inline:var(--beacon-form-field-space-padding)}:is(input.error,input.error:focus){--border-size: var(--beacon-form-field-size-border-width-error);--border-color: var(--beacon-form-field-color-border-error)}input:focus-visible{--heritage-width-border-normal: calc(var(--beacon-unit-base) / 8);--heritage-width-border-jumbo: calc(var(--beacon-unit-base) / 4);--heritage-width-border-maxi: calc(var(--beacon-unit-base) / 2);--total-ring-width: calc( var(--beacon-system-width-border-jumbo, var(--heritage-width-border-jumbo)) + var(--beacon-system-width-border-maxi, var(--heritage-width-border-maxi)) + var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)) );outline:var(--beacon-system-width-border-normal, var(--heritage-width-border-normal)) solid var(--beacon-system-color-border-focus-middle, var(--beacon-color-outline-focus));outline-offset:var(--beacon-system-width-border-normal, var(--heritage-width-border-normal));position:relative;z-index:1}input:not([type=date]).error{--font-color: var(--beacon-form-field-color-text-error)}input:not([type=date]).error:focus{--font-color: var(--beacon-form-field-color-text-default)}:host([icon-position]) input{background-image:var(--input-field-icon, none);background-position:var(--input-icon-position, none);background-repeat:no-repeat}:host([icon-position=left]){--input-icon-position: var(--beacon-form-icon-space-position-inline-start)}:host([icon-position=left]) input:not([type=date]){padding-inline-start:var(--beacon-form-icon-space-padding)}:host([icon-position=right]){--input-icon-position: var(--beacon-form-icon-space-position-inline-end)}:host([icon-position=right]) input:not([type=date]){padding-inline-end:var(--beacon-form-icon-space-padding)}`;
var z = Object.defineProperty, e = (m, t, i, N) => {
  for (var a = void 0, c = m.length - 1, h; c >= 0; c--)
    (h = m[c]) && (a = h(t, i, a) || a);
  return a && z(t, i, a), a;
};
const l = class l extends I(T) {
  constructor() {
    super(...arguments), this.beaconTagName = o.beaconTagName, this.focusOverride = !0, this.name = "input-field", this.iconPosition = d.NONE, this.iconUrl = "", this.format = "", this.formatType = p.PATTERN;
  }
  static get styles() {
    return [super.styles, P];
  }
  /**
   * Getter property for the icon URL. Requires both a URL and position to be set.
   * @returns {string} CSS variable of the icon's URL
   */
  get icon() {
    return this.iconUrl && (this.iconPosition === d.LEFT || this.iconPosition === d.RIGHT) ? `${o.iconCSSVar}: url(${this.iconUrl});` : "";
  }
  /**
   * Getter for the this.format depending on the formatType
   */
  get properFormat() {
    return this.formatType === p.REGEXP ? new RegExp(this.format) : this.format;
  }
  /**
   * Initialize IMask using the supplied format. Input fields are required to be `[type="text"]` to use IMask.
   * @link https://imask.js.org/guide.html.
   */
  implementFormatting() {
    if (this.format) {
      this.formatStore = v(this.input, {
        mask: this.properFormat
      });
      const t = () => {
        this.value = this.formatStore.value, this.internals && (this == null || this.internals.setFormValue(this.value));
      };
      this.formatStore.on("accept", t);
    }
  }
  /** Override the FormBase handleInput method to account for possible formatting */
  handleInput(t) {
    var i;
    this.formatStore ? (this.value = this.formatStore.value, (i = this.internals) == null || i.setFormValue(this.value)) : this.captureEventValue(t), this.emitInput(t, { internals: this.internals, value: this.value, target: t == null ? void 0 : t.target });
  }
  /* eslint-disable consistent-return */
  updated(t) {
    if (!this.formatStore)
      return this.implementFormatting();
    if (t.has(o.formatProp) || t.has(o.formatTypeProp))
      return this.formatStore.updateOptions({
        mask: this.properFormat
      });
  }
  render() {
    var t, i;
    return this.invalid = !((t = this.internals) != null && t.checkValidity()), f`
      <label for="${this.id}">${this.label}</label>
      ${this.hint ? f`<p class="${o.HINT_ID}" id="${o.HINT_ID}">${this.hint}</p>` : b}
      ${this.invalid ? y`<${this.getScopedTag(o.beaconErrorTagName)} message="${(i = this.internals) == null ? void 0 : i.validationMessage}" id="${o.ERROR_ID}"></${this.getScopedTag(o.beaconErrorTagName)}>` : b}
      <input
        style=${this.icon}
        class="${this.invalid ? o.ERROR_ID : ""} form-anchor"
        title=${n(this.title)}
        type=${this.formatStore ? w.TEXT : this.type}
        id=${this.id}
        name=${this.name}
        .value=${this.value}
        aria-describedby="${n(
      this.hint || this.invalid ? [this.hint ? o.HINT_ID : "", this.invalid ? o.ERROR_ID : ""].join(" ").trim() : void 0
    )}"
        aria-invalid=${u(this.invalidStateAsString)}
        aria-disabled=${u(this.disabledStateAsString)}
        pattern=${n(this.pattern)}
        minlength=${n(this.minlength)}
        maxlength=${n(this.maxlength)}
        ?required=${this.required}
        ?invalid=${this.invalid}
        @blur=${this.handleBlur}
        @change=${this.emitChange}
        @input=${this.handleInput}
        @focus=${this.emitFocus}
        @click=${this.emitClick}
        @keydown=${this.handleKeydown}
        @mousedown=${this.handleMousedown}
      />
    `;
  }
};
l.tagName = o.beaconTagName, l.nestedComponents = o.beaconNestedComponents;
let r = l;
e([
  s({ reflect: !0 })
], r.prototype, "name");
e([
  s({ attribute: o.iconPositionProp })
], r.prototype, "iconPosition");
e([
  s({ attribute: o.iconUrlProp })
], r.prototype, "iconUrl");
e([
  s()
], r.prototype, "format");
e([
  s({ attribute: o.formatTypeAttr })
], r.prototype, "formatType");
e([
  S("input")
], r.prototype, "input");
e([
  $()
], r.prototype, "formatStore");
export {
  r as BeaconInputField
};
